<!--
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-01-26 14:31:14
 * @FilePath: /visaai-platform/src/views/Web.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="web">
    <iframe :src="iframeSrc" frameborder="0"></iframe>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getWebURL, getDomain, getCookie } from "@/utils/util";
export default {
  name: "web",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      path: "",
      countryId: "",
    };
  },
  computed: {
    iframeSrc() {
      let baseURL = "";
      let path = this.$route.query.path || "/";
      switch (this.type) {
        case "mall":
          baseURL = getWebURL("mall");
          break;
        case "mallDetails":
          console.log(getWebURL("mallDetails"), "mall");
          baseURL = getWebURL("mallDetails");
          break;
        case "ticket":
          baseURL = getWebURL("ticket");
          break;
        case "online":
          baseURL = getWebURL("online");
          // location.href = getWebURL("online") + `/web/online`;
          break;
        default:
          break;
      }
      if (path.includes("?")) {
        path += "&now=" + new Date().getTime();
      } else {
        path += "?now=" + new Date().getTime();
      }

      return baseURL + path;
    },
  },
  mounted() {
    document.domain = getDomain();
    window.addEventListener("message", this.handleMessagePost);
  },
  destroyed() {
    window.removeEventListener("message", this.handleMessagePost);
  },
  methods: {
    ...mapActions(["setBalance"]),

    handleMessagePost(e) {
      if (e.type === "message") {
        switch (e.data.type) {
          case "IFRAME_OPEN_WINDOW": // 打开新窗口
            window.open(getWebURL(e.data.name) + e.data.path);
            break;
          case "IFRAME_OPEN_NEW_WINDOW": // 打开新窗口 保险打开其他域名新页面
            this.mallOpenNewOpen(e);
            break;
          case "IFRAME_JUMP_PAGE": // 跳转页面
            // let searchObj = this.getLocationSearch();
            console.log(this.getLocationSearch(), "this.getLocationSearch()");
            if (this.getLocationSearch().userInfo) {
              if (this.getLocationSearch().mode == "newTest") {
                window.location.href =
                  "http://h5-visas-platform.qa.visaapp6.com/?mode=newTest#" + e.data.path;
              } else {
                window.location.href = "https://platform.visaai.com/#" + e.data.path;
              }
            } else {
              this.$router.push(e.data.path);
            }

            break;
          case "REFRESH_BALANCE": // 刷新账户余额
            this.setBalance();
            break;
          case "RE_LOGIN":
            window.location.href = getWebURL("visa") + "/login";
            break;
          case "RE_Home":
            window.location.href = getWebURL("visa") + "/country";
            break;
          case "RE_Order":
            window.location.href = getWebURL("visa") + "/order";
            break;
          default:
            break;
        }
      }
    },
    mallOpenNewOpen(e) {
      const searchObj = this.getLocationSearch();
      let cookiesArr = document.cookie.split("; ");
      const cookieObj = {};
      cookiesArr.forEach((item) => {
        if (item) {
          const [key, value] = item.split("=");
          if (key === "userInfo") {
            cookieObj[key] = JSON.parse(decodeURIComponent(value));
          } else {
            cookieObj[key] = value;
          }
        }
      });
      // window.open(
      //     `http://localhost:8090/?mode=newTest&userInfo=${encodeURIComponent(
      //       JSON.stringify(cookieObj.userInfo)
      //     )}#` + e.data.path
      //   );

      //鼎立链接
      // if (searchObj.mode == "newTest") {
      //   window.open(
      //     `http://h5-visas-platform.bx-pre.dlbxjj.com/?mode=newTest&userInfo=${encodeURIComponent(
      //       JSON.stringify(cookieObj.userInfo)
      //     )}#` + e.data.path
      //   );
      // } else {
      //   window.open(
      //     `https://bx.dlbxjj.com/?userInfo=${encodeURIComponent(
      //       JSON.stringify(cookieObj.userInfo)
      //     )}#` + e.data.path
      //   );
      // }

      if (searchObj.mode == "newTest") {
        window.open(
          `http://h5-visas-platform.bx-pre.dlbxjj.com/?mode=newTest&userInfo=${encodeURIComponent(
            JSON.stringify(cookieObj.userInfo)
          )}#` + e.data.path
        );
      } else {
        window.open(
          `https://jdal.meditrustbroker.com/?userInfo=${encodeURIComponent(
            JSON.stringify(cookieObj.userInfo)
          )}#` + e.data.path
        );
      }
    },
    getLocationSearch() {
      const searchObj = {};
      const searchMath = window.location.href.match(/\?(.+)#\//);
      if (searchMath) {
        const searchStr = searchMath[1];
        if (searchStr) {
          searchStr.split("&").forEach((item) => {
            if (item) {
              const [key, value] = item.split("=");
              searchObj[key] = value;
            }
          });
        }
      }
      return searchObj;
    },
  },
};
</script>

<style lang="scss">
.web {
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
